/* eslint-disable no-unused-vars */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "./router/AppRouter";
import { setThemeLS } from "./store/theme/themeSlice";
import {
  startLoggedInWithTokenLS,
  startLoggedOut,
} from "./store/auth/authThunks";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "./theme/styles.scss";
import { startSetSize, startSetThemeLS } from "./store/theme/themeThunks";
import { startGettingLanguageLS } from "./store/lang/langThunks";
import { useTranslation } from "react-i18next";
import { setOnline } from "./store/online/onlineSlice";
import { closeSnackbar, useSnackbar } from "notistack";
import statuscode_es from "./translations/ES/statuscode.json";
import statuscode_en from "./translations/EN/statuscode.json";

//Esto es para reac query (caché)

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10,
      cacheTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
    },
  },
});

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
});

export const App = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [t, i18n] = useTranslation();
  const lang = localStorage.getItem("lang") || "es";
  const language = lang === "es" ? statuscode_es : statuscode_en;

  useEffect(() => {
    const lostConection = () => {
      enqueueSnackbar(`${language.no_internet_conection}`, {
        variant: "error",
        anchorOrigin: { horizontal: "center", vertical: "top" },
        preventDuplicate: true,
        persist: true,
      });
    };

    const onlineStatusHandler = () => {
      dispatch(setOnline(navigator.onLine));

      if (!navigator.onLine) {
        lostConection();
      } else {
        closeSnackbar(lostConection());
        enqueueSnackbar(`${language.internet_connection_reestablished}`, {
          variant: "success",
          anchorOrigin: { horizontal: "center", vertical: "top" },
        });
      }
    };

    window.addEventListener("online", onlineStatusHandler, { passive: true });
    window.addEventListener("offline", onlineStatusHandler, { passive: true });
    return () => {
      window.removeEventListener("online", onlineStatusHandler);
      window.removeEventListener("offline", onlineStatusHandler);
    };
  }, [dispatch, enqueueSnackbar]);

  useEffect(() => {
    dispatch(startGettingLanguageLS(i18n));
  }, [dispatch, i18n]);

  useEffect(() => {
    dispatch(startSetThemeLS());
  }, [dispatch]);

  useEffect(() => {
    dispatch(startLoggedInWithTokenLS());
  }, [dispatch]);

  return (
    <>
      <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppRouter />        
      </BrowserRouter>
    </QueryClientProvider>
    </>
  );
};
